import { render } from "./ContactCoach.vue?vue&type=template&id=2587237c&scoped=true"
import script from "./ContactCoach.vue?vue&type=script&lang=js"
export * from "./ContactCoach.vue?vue&type=script&lang=js"

import "./ContactCoach.vue?vue&type=style&index=0&id=2587237c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2587237c"

export default script